import React from "react";
import { useParams } from "react-router";
import { SpinnerRoundFilled } from "spinners-react";
import axios from "axios";
import Cookies from "universal-cookie";


const cookie = new Cookies();

export default function LoginVerification(){
  const params = useParams();

  axios
      .post(
        "https://ferias-ingenio-backend.vercel.app/api/users/account_verification",
        {id: params.account}
      )
      .then((res) => {
        console.log(res.data);
        if (res.data.code == 200) {
          cookie.set("id", res.data.doc.id, { path: "/" });
          cookie.set("username", res.data.doc.username, { path: "/" });
          cookie.set("email", res.data.doc.email, { path: "/" });
          cookie.set("likes", res.data.doc.likes, { path: "/" });
          cookie.set("photo", res.data.doc.photo, { path: "/" });
          if (!res.data.doc.admin) {
            if (!res.data.doc.judge) {
              window.location.href = "/categories";
            } else {
              window.location.href = "/judges";
              cookie.set("judge", res.data.doc.judge, { path: "/" });
            }
          } else {
            window.location.href = "/administration";
            cookie.set("admin", res.data.doc.admin, { path: "/" });
          }
        } else {
          window.location.href = "/account";
        }
      })
      .catch((err) => {
        console.log(err);
      });

  return(
    <div className="LoginVerification-container">
      <img src={require("../../assets/images/logoFeria.png")} />
      <h1>Veficando Cuenta</h1>
      <SpinnerRoundFilled />
    </div>
  );
}